import React from 'react';

var TopLink = function TopLink(_ref) {
  var className = _ref.className,
      anchorText = _ref.anchorText,
      onHandleClick = _ref.onHandleClick;
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    onClick: function onClick() {
      return onHandleClick();
    }
  }, anchorText);
};

export default TopLink;